import { render, staticRenderFns } from "./PageComprobantes.vue?vue&type=template&id=3815fcde&"
import script from "./PageComprobantes.vue?vue&type=script&lang=js&"
export * from "./PageComprobantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports